import type {BigCalendarEvent} from 'platform/big-calendar';

import type {TestDriveCalendarEvent} from './TestDriveCalendarEvent';

export function isTestDriveEvent(event: BigCalendarEvent): event is TestDriveCalendarEvent {
  return event.eventType === 'testDrive';
}
